'use client';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import logo from '../../../public/LOGO.svg';
import { FiMenu, FiX } from 'react-icons/fi';
import { useState } from 'react';
import Button from './Button';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const pathname = usePathname();

  return (
    <nav className="mt-0 md:my-8 bg-white shadow-md sticky top-0 z-50 mx-0 md:mx-6 lg:mx-16 border border-gray-100 rounded-none md:rounded-xl drop-shadow-lg">
      <div className="container mx-auto flex items-center justify-between py-4 px-10 md:px-4 lg:px-14">
        
        {/* Logo */}
        <Link href="/">
          <Image 
            src={logo} 
            alt="MashonaDev Logo" 
            width={150} 
            height={40} 
            className="cursor-pointer" 
          />
        </Link>

        {/* Navigation Links - Desktop Centered */}
        <div className="hidden md:flex flex-grow justify-center space-x-6 text-base">
          {['Home', 'Services', 'Careers', 'About us'].map((item) => {
            const linkPath = item === "Home" ? "/" : `/${item.toLowerCase().replace(" ", "-")}`;
            const isActive = pathname === '/' && item === 'Home' || pathname === linkPath;

            return (
              <Link key={item} href={linkPath}>
                <span
                  className={`cursor-pointer ${isActive ? 'text-orange-500 font-bold' : 'text-gray-700 hover:text-orange-500'}`}
                >
                  {item}
                </span>
              </Link>
            );
          })}
        </div>

        {/* Contact Us Button - Desktop (Far Right) */}
        <div className="hidden md:block py-2">
          <Button href="/contact">Contact us</Button>
        </div>

        {/* Hamburger Icon for Mobile */}
        <div className="md:hidden">
          {isMenuOpen ? (
            <FiX
              className="text-2xl cursor-pointer text-black"
              onClick={toggleMenu}
            />
          ) : (
            <FiMenu
              className="text-2xl cursor-pointer text-black"
              onClick={toggleMenu}
            />
          )}
        </div>

        {/* Mobile Menu (Links + Contact Us) */}
        <div
          className={`${
            isMenuOpen
              ? "block absolute top-14 left-0 w-full bg-white shadow-md rounded-b-lg"
              : "hidden"
          } md:hidden`}
        >
          {['Home', 'Services', 'Careers', 'About us'].map((item) => {
            const linkPath = item === "Home" ? "/" : `/${item.toLowerCase().replace(" ", "-")}`;
            const isActive = pathname === '/' && item === 'Home' || pathname === linkPath;

            return (
              <Link key={item} href={linkPath}>
                <span
                  className={`block py-3 px-6 text-center cursor-pointer ${isActive ? 'text-orange-500 font-bold' : 'text-gray-700 hover:text-orange-500'}`}
                >
                  {item}
                </span>
              </Link>
            );
          })}

          {/* Contact Us Button - Mobile */}
            <div className="py-8 px-6">
            <Button href="/contact" className="w-full block text-center">
              Contact us
            </Button>
            </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
